import { t } from '@framework/i18n/intl/i18next.ts';
import { modalConfirm } from '../../../../../../ui/modal/modalConfirm.tsx';

/**
 * Dialog di conferma per l'annullamento delle modifiche nei widget di
 * selezione avanzata (multi e singola).
 */
export function confirmCancelChanges(): Promise<boolean> {
  return modalConfirm({
    title: t(
      'widgets.advanced-select.cancel-changes-confirm-title',
      'Annullare le modifiche?',
    ),
    content: t(
      'widgets.advanced-select.cancel-changes-confirm-content',
      "La selezione verrà ripristinata al valore precedente all'apertura del popup.",
    ),
    okText: t(
      'widgets.advanced-select.cancel-changes-confirm-ok',
      'Annulla modifiche',
    ),
    cancelText: t(
      'widgets.advanced-select.cancel-changes-confirm-cancel',
      'Continua',
    ),
  });
}

/**
 * Dialog di conferma per la cancellazione della selezione nei widget di
 * selezione avanzata (multi e singola).
 */
export function confirmClearSelection(): Promise<boolean> {
  return modalConfirm({
    title: t(
      'widgets.advanced-select.delete-selection-confirm-title',
      'Cancellare la selezione?',
    ),
    content: t(
      'widgets.advanced-select.delete-selection-confirm-content',
      'La selezione corrente verrà rimossa.',
    ),
    okText: t(
      'widgets.advanced-select.delete-selection-confirm-ok',
      'Cancella',
    ),
    cancelText: t(
      'widgets.advanced-select.delete-selection-confirm-cancel',
      'Indietro',
    ),
  });
}
